import React, { Component } from "react";
import { withAuth } from "../Auth/WithAuth";
import { authenticatedFetch } from "../../utils/apiClient";

let isMounted = false;

export default withAuth(
  class MovedUsers extends Component {
    constructor(props) {
      super(props);
      this.state = {
        movedUsers: {},
        updated: Date().toLocaleString()
      };

      this.getMovedUsers = this.getMovedUsers.bind(this);
      this.timeStampHandler = this.timeStampHandler.bind(this);
      this.deleteMoveLog = this.deleteMoveLog.bind(this);
    }

    async componentDidMount() {
      isMounted = true;
      this.getMovedUsers();
    }

    componentWillMount() {
      clearInterval(this.interval);
    }

    componentDidUpdate() {
      // Authentication is now handled by WithAuth HOC
    }

    componentWillUnmount() {
      isMounted = false;
    }

    async getMovedUsers() {
      try {
        authenticatedFetch("/api/admin/getMovedUsers", {
          method: "get",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            pragma: "no-cache",
            "cache-control": "no-cache"
          }
        })
          .then(response => {
            return response.json();
          })
          .then(movedUserData => {
            this.setState({ movedUsers: movedUserData });
            this.setState({ updated: Date().slice(16, 24) });
          })
          .catch(err => {
            console.log(err);
          });
      } catch (err) {
        console.log(err);
      }
    }

    timeStampHandler(timestamp) {
      try {
        if (timestamp !== undefined) {
          const time = parseInt(timestamp);
          const date = new Date(time);

          const dateString =
            ("0" + date.getDate()).slice(-2) +
            "-" +
            ("0" + (date.getMonth() + 1)).slice(-2) +
            "-" +
            date.getFullYear() +
            " " +
            ("0" + date.getHours()).slice(-2) +
            ":" +
            ("0" + date.getMinutes()).slice(-2);

          return dateString;
        } else {
          return "";
        }
      } catch (e) {
        return "";
      }
    }

    async deleteMoveLog(moveLogId, userName) {
      if (window.confirm(`Er du sikker på at du vil slette flytteloggen for ${userName}?`)) {
        try {
          const response = await authenticatedFetch(`/api/admin/deleteMoveLog/${moveLogId}`, {
            method: "DELETE"
          });

          if (response.ok) {
            // Refresh the moved users list
            this.getMovedUsers();
            this.setState({ updated: Date().toLocaleString() });
          } else {
            alert("Feil ved sletting av flyttelogg");
          }
        } catch (err) {
          console.error("Error deleting move log:", err);
          alert("Nettverksfeil ved sletting av flyttelogg");
        }
      }
    }

    render() {
      if (this.props.authenticated === null) return null;
      const movedUserRows = [];
      
      for (let i = 0; i < this.state.movedUsers.length; i++) {
        const user = this.state.movedUsers[i];
        const userName = `${user.firstName} ${user.lastName}`;
        movedUserRows.push(
          <tr key={i}>
            <td>{user.code}</td>
            <td>{userName}</td>
            <td>{user.oldRowNum}:{user.oldSeatNum}</td>
            <td>{user.newRowNum}:{user.newSeatNum}</td>
            <td>{user.reason}</td>
            <td>{this.timeStampHandler(user.timestamp)}</td>
            <td>{user.UpdatedBy}</td>
            <td>
              <button style={{cursor:'pointer'}}
                className="btn btn-danger btn-sm"
                onClick={() => this.deleteMoveLog(user._id, userName)}
                title="Slett flyttelogg"
              >
                X
              </button>
            </td>
          </tr>
        );
      }

      let numberMoved = <h5>Antall flyttede brukere: {movedUserRows.length} </h5>;

      return (
        <div>
          <p>Oppdatert: {this.state.updated}</p>
          {numberMoved}
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Kode</th>
                <th>Navn</th>
                <th>Fra plass</th>
                <th>Til plass</th>
                <th>Grunn</th>
                <th>Tidspunkt</th>
                <th>Flyttet av</th>
                <th>Handlinger</th>
              </tr>
            </thead>
            <tbody>{movedUserRows}</tbody>
          </table>
        </div>
      );
    }
  }
);


// WEBPACK FOOTER //
// ./src/Components/Admin/MovedUsers.js